
export default {
  name: 'FButtonOptions',

  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [Array, String, Object, Boolean, Number],
      default: null,
    },
    options: {
      type: Array,
      required: true,
      validator: (value) =>
        value.every(
          (v) =>
            typeof v === 'string' ||
            typeof v === 'object' ||
            typeof v === 'number',
        ),
    },
    disabled: {
      type: Boolean,
    },
    maximum: {
      type: [Number, String],
      default: 2,
    },
    mandatory: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
    },
    group: {
      type: Boolean,
      default: true,
    },
    borderless: {
      type: Boolean,
      default: true,
    },
    rounded: {
      type: Boolean,
    },
    tile: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
    },
    hideDetails: {
      type: [Boolean, String],
      default: false,
    },
    large: {
      type: Boolean,
    },
  },

  methods: {
    bubbleEvent(value) {
      this.$emit('change', value);
    },
  },
};
